import React from 'react';
import { Flex, Skeleton } from '@skin-seoul/design-system';
const TopRankedCategoryFilterSkeleton = () => {
  return <Flex gap={2} width="100%" data-sentry-element="Flex" data-sentry-component="TopRankedCategoryFilterSkeleton" data-sentry-source-file="TopRankedCategoryFilterSkeleton.tsx">
      {Array.from({
      length: 6
    }).map((_, index) => <Skeleton key={index} height="40px" minWidth="120px" borderRadius="20px" background="rgba(255, 255, 255, 0.1)" />)}
    </Flex>;
};
export default TopRankedCategoryFilterSkeleton;